export const ru = {
    adjust: 'Уточнить',
    cancel: 'Отмена',
    'phrase-with-minus-words': 'Фраза с минус-словами',
    set: 'Ок'
};
